import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from "@angular/core";
import { environment } from "../../environments/environment";
import { ArticleService } from "../service/article.service";
import { LazyImgDirective } from "../lazy-img.directive";
import { ImgFallbackDirective } from "../shared/img-fallback.directive";
import { MatButton } from "@angular/material/button";

@Component({
  selector: "app-new-screen-four",
  templateUrl: "./new-screen-four.component.html",
  styleUrls: ["./new-screen-four.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LazyImgDirective, ImgFallbackDirective, MatButton]
})
export class NewScreenFourComponent implements OnInit {
  blogdata: object[] = [];
  blogdataRaw: object[] = [];
  should_not: object[] = [];

  constructor(
    private service: ArticleService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.should_not = [];
    let pending = 3;
    const done = () => {
      // Apply the blog filter only after all three calls resolve, so should_not
      // (top-story + exclusive slugs) is complete — fixes the race where the
      // insights list sometimes duplicated the top-story/exclusive articles
      // depending on which call returned first.
      if (--pending === 0) this.applyBlogFilter();
    };
    this.get_exclusiveStory(done);
    this.get_topStories(done);
    this.BlogData(done);
  }

  get_topStories(onComplete?: () => void) {
    this.service
      .get_article({ is_top_story: true, limit: 12 })
      .subscribe({
        next: data => {
          if (data["success"]) {
            data["data"].forEach(item => {
              this.should_not.push(item["slug"]);
            });
          }
          if (onComplete) onComplete();
        },
        error: () => {
          if (onComplete) onComplete();
        }
      });
  }

  get_exclusiveStory(onComplete?: () => void) {
    this.service
      .get_article({ is_exclusive: true, limit: 3 })
      .subscribe({
        next: data => {
          if (data["success"]) {
            data["data"].forEach(item => {
              this.should_not.push(item["slug"]);
            });
          }
          if (onComplete) onComplete();
        },
        error: () => {
          if (onComplete) onComplete();
        }
      });
  }

  BlogData(onComplete?: () => void) {
    this.service.get_article({ category: "cme", limit: 30 }).subscribe({
      next: data => {
        if (data["success"]) this.blogdataRaw = data["data"];
        if (onComplete) onComplete();
      },
      error: () => {
        if (onComplete) onComplete();
      }
    });
  }

  applyBlogFilter() {
    this.blogdata = (this.blogdataRaw || []).filter(
      item =>
        item["image_url"] != null &&
        item["headline"] != "" &&
        !this.should_not.includes(item["slug"])
    );
    this.cdr.markForCheck();
  }

  buildHrefLink(story) {
    let href_link = environment.frontend_url;
    switch (story["main_category"]) {
      case "insights":
        href_link += `insights/${story["category"]}/${story["blog_category"]}/`;
        break;
      case "podcast":
        href_link += `podcast/${story["event"]}/`;
        break;
      default:
        href_link += `tv/${story["event"]}/${story["category"]}/`;
    }
    return href_link + story["slug"];
  }
}
